import {
  faArrowDown as ArrowDownIcon,
  faArrowUp as ArrowUpIcon
} from '@fortawesome/pro-light-svg-icons';
import { faCircleExclamation as ExclamationPoint } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, CardContent, CardHeader, Chip, Tooltip } from '@mui/material';
import { useRef } from 'react';

import useStyles from './SmallCard.styles';
import type { SmallCardProps } from './SmallCard.types';

// Small card for displaying data, with a title, content, and optional chip
const SmallCard = (props: SmallCardProps) => {
  const {
    color,
    title,
    primaryContent,
    chipContent,
    onCardClick,
    tooltipText,
    secondaryContent
  } = props;
  const { classes } = useStyles({ color, chipContent });
  const ref = useRef<HTMLDivElement>(null);

  return (
    <Card
      onClick={() => (onCardClick ? onCardClick(title) : null)}
      ref={ref}
      className={classes.smallCard}
    >
      <CardHeader title={title} className={classes.smallCardHeader} />
      <CardContent className={classes.smallCardContent}>
        {typeof primaryContent === 'string' ||
        typeof primaryContent === 'number' ? (
          <div className={classes.smallCardContentContainer}>
            <div className={classes.smallCardContentPrimary}>
              {primaryContent}
            </div>
            {secondaryContent && (
              <div className={classes.smallCardContentSecondary}>
                {secondaryContent}
              </div>
            )}
          </div>
        ) : (
          primaryContent
        )}
        {chipContent && (
          <Chip
            size="medium"
            className={classes.chip}
            label={
              parseFloat(chipContent) <= 0 ? chipContent : `+${chipContent}`
            }
            variant="twoTone"
            color={parseFloat(chipContent) < 0 ? 'success' : 'error'}
            icon={
              <FontAwesomeIcon
                icon={
                  parseFloat(chipContent) <= 0 ? ArrowDownIcon : ArrowUpIcon
                }
              />
            }
          />
        )}
        {tooltipText && (
          <div className={classes.tooltipContainer}>
            <Tooltip title={tooltipText}>
              <FontAwesomeIcon
                className={classes.tooltip}
                icon={ExclamationPoint}
              />
            </Tooltip>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default SmallCard;
